import { Dot } from "lucide-react";

type FlowEvent = {
  second: number;
  title: string;
  detail: string;
};

type TimelineProps = {
  events: FlowEvent[];
  activeEventIndex: number;
  formatClock: (second: number) => string;
  onSeekTo: (second: number) => void;
};

export default function Timeline({
  events,
  activeEventIndex,
  formatClock,
  onSeekTo,
}: TimelineProps) {
  return (
    <div className="rounded-xl border border-border bg-bg p-3">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.16em] text-text-faint">
        What&apos;s happening now
      </h2>
      <div className="space-y-2">
        {events.map((event, index) => {
          const isActive = index === activeEventIndex;
          return (
            <button
              type="button"
              key={event.second}
              aria-current={isActive ? "true" : undefined}
              onClick={() => onSeekTo(event.second)}
              className={`group flex w-full items-start gap-2 rounded-lg border px-3 py-2 text-left transition ${
                isActive
                  ? "border-primary-border bg-primary-dim"
                  : "border-border bg-bg-secondary hover:border-primary-border hover:bg-bg-hover"
              }`}
            >
              <div className="mt-0.5 text-xs font-semibold text-text-faint">
                {formatClock(event.second)}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center text-sm font-semibold text-text">
                  <Dot className={`h-4 w-4 ${isActive ? "text-primary" : "text-text-faint"}`} />
                  {event.title}
                </div>
                <p className="mt-0.5 text-xs leading-relaxed text-text-muted">{event.detail}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
